import "./src/styles/global.scss"
import "katex/dist/katex.min.css"
require("prismjs/themes/prism-solarizedlight.css")
